/* eslint-disable no-useless-escape */
export const URL_REG_EXP =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
export const TITLE = 'Анатомия';
export const ANATOMY_URL = 'https://uchi.ru/modern-subjects/anatomy';
export const PRODUCT_NAME = 'modern_anatomy';
